import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfigurationPlan } from '../../../../../models/configurators-2d/applications/workbench/configurations/configuration-plan';
import { ConfigurationGroup } from '../../../../../models/configurators-2d/applications/workbench/configurations/configuration-group';
import { MaterialTypeEnum } from 'src/app/enum/workbench/material-type-enum';

@Component({
  selector: 'ng-workbench-jambs-infos',
  templateUrl: './jambs-infos.component.html',
})
export class WorkbenchJambsInfosComponent implements OnInit {
  @Input() planOrGroup: ConfigurationPlan | ConfigurationGroup;
  @Input() collapseIsVisible: boolean;
  @Output() onPlanOrGroupSelected: EventEmitter<void> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
    if (!this.collapseIsVisible) {
      this.toggleCollapse();
    }
  }

  toggleCollapse(): void {
    this.collapseIsVisible = !this.collapseIsVisible;
    this.onPlanOrGroupSelected.emit();
  }

  getPlanNames(): string {
    if (this.planOrGroup instanceof ConfigurationGroup) {
      let planNames = '(';

      for (const [i, plan] of this.planOrGroup.workbenchConfigurationPlans
        .sort((a, b) => a.name.localeCompare(b.name))
        .entries()) {
        planNames += plan.name;

        if (i !== this.planOrGroup.workbenchConfigurationPlans.length - 1) {
          planNames += ', ';
        }
      }

      return planNames + ')';
    } else {
      return '';
    }
  }

  getJambsHeight(): number {
    let configurationPlan: ConfigurationPlan;

    if (this.planOrGroup instanceof ConfigurationGroup) {
      configurationPlan = this.planOrGroup.workbenchConfigurationPlans.find(p => p.configurationJambs.length > 0);
    } else {
      configurationPlan = this.planOrGroup;
    }

    return configurationPlan.configurationJambs[0]?.height ?? 0;
  }

  changeJambsHeight(event: Event): void {
    const height = parseInt((event.target as HTMLInputElement).value);
    if (this.planOrGroup instanceof ConfigurationGroup) {
      for (const workbenchConfigurationPlan of this.planOrGroup.workbenchConfigurationPlans) {
        for (const configurationJamb of workbenchConfigurationPlan.configurationJambs) {
          configurationJamb.height = height;
        }
      }
    } else {
      for (const configurationJamb of this.planOrGroup.configurationJambs) {
        configurationJamb.height = height;
      }
    }
  }

  jambCanHavePolish(): boolean {
    return this.getConfigurationPlan().materialThickness.jambsCanHavePolish;
  }

  /**
   * Seul le quartz peut avoir des découpes de côté en bizeau à 45°
   */
  jambCanHave45DegreesSideCut(): boolean {
    return this.getConfigurationPlan().material.materialType === MaterialTypeEnum.Quartz;
  }

  getJambsHavePolish(): boolean {
    return this.getConfigurationPlan().configurationJambs[0]?.havePolish ?? false;
  }

  getJambsHave45DegreesSideCut(): boolean {
    return this.getConfigurationPlan().configurationJambs[0]?.have45DegreesSideCut ?? false;
  }

  changeJambsHavePolish(event: Event): void {
    const havePolish = (event.target as HTMLInputElement).checked;
    if (this.planOrGroup instanceof ConfigurationGroup) {
      for (const workbenchConfigurationPlan of this.planOrGroup.workbenchConfigurationPlans) {
        for (const configurationJamb of workbenchConfigurationPlan.configurationJambs) {
          configurationJamb.havePolish = havePolish;
        }
      }
    } else {
      for (const configurationJamb of this.planOrGroup.configurationJambs) {
        configurationJamb.havePolish = havePolish;
      }
    }
  }

  changeJambsHave45DegreesSideCut(event: Event): void {
    const have45DegreesSideCut = (event.target as HTMLInputElement).checked;
    if (this.planOrGroup instanceof ConfigurationGroup) {
      for (const workbenchConfigurationPlan of this.planOrGroup.workbenchConfigurationPlans) {
        for (const configurationJamb of workbenchConfigurationPlan.configurationJambs) {
          configurationJamb.have45DegreesSideCut = have45DegreesSideCut;
        }
      }
    } else {
      for (const configurationJamb of this.planOrGroup.configurationJambs) {
        configurationJamb.have45DegreesSideCut = have45DegreesSideCut;
      }
    }
  }

  private getConfigurationPlan(): ConfigurationPlan {
    if (this.planOrGroup instanceof ConfigurationGroup) {
      return this.planOrGroup.workbenchConfigurationPlans.find(p => p.configurationJambs.length > 0);
    } else {
      return this.planOrGroup;
    }
  }
}
